import { Box, Tag, Text, Tooltip } from '@nimbus-ds/components';
import { CloseIcon, EditIcon } from '@nimbus-ds/icons';
import { Layout } from '@nimbus-ds/patterns';
import { useTranslationCommon } from 'commons/hooks';
import { ChatHeaderProps } from './types';
import { useAgentChatContext } from '../../contexts';
import { trackAgentChatConversationReset } from '../../tracking';

/**
 * ChatHeader provides the top navigation bar for the chat modal
 * with recent items, title, and close functionality.
 */
function ChatHeader({ onClose }: Readonly<ChatHeaderProps>): JSX.Element {
  const t = useTranslationCommon('ai.agent');
  const { clearConversation, messages, sessionId } = useAgentChatContext();

  const handleClearConversation = () => {
    trackAgentChatConversationReset({
      messageCount: messages.length,
      sessionId,
    });
    clearConversation();
  };

  return (
    <Layout columns="3" p="3">
      <Layout.Section>
        {/* Empty box to maintain the Layout columns */}
        <Box />
      </Layout.Section>
      <Layout.Section justifyContent="center">
        <Box display="flex" alignItems="center" gap="2" justifyContent="center">
          <Text fontSize="highlight" color="neutral-textHigh">
            {t('title')}
          </Text>
          <Tag appearance="neutral">{t('betaTag')}</Tag>
        </Box>
      </Layout.Section>
      <Layout.Section marginLeft="8">
        <Box justifyContent="flex-end" alignSelf="center" display="flex">
          <Tooltip content={t('newConversation')} position="bottom">
            <Box
              p="1-5"
              as="button"
              type="button"
              onClick={handleClearConversation}
              aria-label={t('newConversation')}
              backgroundColor="transparent"
              display="flex"
              alignItems="center"
              justifyContent="center"
              cursor="pointer"
            >
              <EditIcon />
            </Box>
          </Tooltip>

          <Box
            p="1-5"
            as="button"
            type="button"
            onClick={onClose}
            aria-label={t('closeButton')}
            backgroundColor="transparent"
            display="flex"
            alignItems="center"
            justifyContent="center"
            cursor="pointer"
          >
            <CloseIcon />
          </Box>
        </Box>
      </Layout.Section>
    </Layout>
  );
}

export default ChatHeader;
